module.exports = __webpack_public_path__ + "img/partner_7.8b629150.png";